/* eslint-disable import/no-cycle */
import { ComponentInputTypeT } from './schemas/types';

export const DRAG_ITEM_TYPES = {
  PALETTE: 'paletteItem',
  FORM_ITEM: 'formItem',
};

export const PALETTE_ITEMS: { type: ComponentInputTypeT; defaultText: string }[] = [
  { type: 'text', defaultText: 'Text Input' },
  { type: 'number', defaultText: 'Number Input' },
  { type: 'date', defaultText: 'Date Picker' },
  { type: 'email', defaultText: 'Email Input' },
  { type: 'phone', defaultText: 'Phone Input' },
  { type: 'yesNo', defaultText: 'Yes/No Question' },
  { type: 'checkbox', defaultText: 'Checkbox Group' },
  { type: 'radio', defaultText: 'Radio Group' },
  { type: 'section', defaultText: 'New Section' },
  { type: 'info', defaultText: 'Info Text' },
  { type: 'address', defaultText: 'Address' },
  // Add all other FormBuilderTypes here with a default label/text
  { type: 'fullName', defaultText: 'Full Name' },
  { type: 'image', defaultText: 'Image Upload' },
  { type: 'file', defaultText: 'File Upload' },
  { type: 'link', defaultText: 'Link' },
  { type: 'button', defaultText: 'Button' },
  { type: 'singleCheckbox', defaultText: 'Single Checkbox' },
  { type: 'gender', defaultText: 'Gender' },
  // ... and so on for the rest
];
